export default {
    visitor: 'Visitor',
    visitorLists: 'Visitor Lists',
    visitorActivity: 'Visitor Activity'
}
